/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ReportProfilePhotoNcmecInternalRequest} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/report_profile_photo_ncmec_internal.pb'
import {ReportProfilePhotoNcmecInternalResponse} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/report_profile_photo_ncmec_internal.pb'


export const reportProfilePhotoNcmecInternal = (request: ReportProfilePhotoNcmecInternalRequest, options?: CashRequestOptions) => post<ReportProfilePhotoNcmecInternalRequest, ReportProfilePhotoNcmecInternalResponse>("/2.0/cash/report-profile-photo-ncmec-internal", request, {...options, rejectOnError: true })